import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/ContactForm.css";

function ContactForm() {

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        phone: "",
        message: "",
        acceptTerms: false
    });

    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        const sanitizedValue = name === "phone" ? value.replace(/\s+/g, '') : value;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : sanitizedValue
        })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Sprawdzenie, czy użytkownik zaakceptował regulamin
        if (!formData.acceptTerms) {
            setError("Musisz zaakceptować regulamin");
            return;
        }
        setError("");
    
        try {
            // Wysyłanie formularza do Web3Forms
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    access_key: "1b7be19e-d6c6-4ea3-ad52-ddf71cc97757",
                    from_name: `${formData.firstName}, ${formData.lastName}`, // Stały nadawca
                    subject: "Nowa wiadomość z formularza Sami Swoi",
                    Imię: formData.firstName,
                    Nazwisko: formData.lastName,
                    Email: formData.email,
                    Telefon: formData.phone,
                    Temat: formData.subject,
                    Wiadomość: formData.message
                })
            });
    
            // Sprawdzenie, czy formularz został wysłany poprawnie
            if (response.ok) {
                console.log("Form submitted:", formData);
    
                // Przekierowanie użytkownika po udanym wysłaniu formularza
                window.location.href = "https://www.jakubowotestowo.store/wyslano";
            } else {
                setError("Błąd przy wysyłaniu formularza. Spróbuj ponownie.");
            }
        } catch (error) {
            console.error("Błąd:", error);
            setError("Coś poszło nie tak. Spróbuj ponownie później.");
        }
    };

    return (
        <div className="container-fluid my-5-5 py-5 contact-form-section-background">
            <div className="container d-flex flex-column">
                <div className="form-title text-center">
                    <h4 className="fs-2">Wyślij do nas wiadomość</h4>
                    <hr className="divider" />
                    <p className="fw-light">Skorzystaj z formularza i zapytaj o cokolwiek!</p>
                </div>
                <div className="contact-form mt-5 mb-2">
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-4">
                            <div className="col-md-6">
                                <input type="text" className="form-control" placeholder="Imię*" name="firstName" value={formData.firstName} onChange={handleChange} required />
                            </div>
                            <div className="col-md-6">
                            <input type="text" className="form-control mt-input" placeholder="Nazwisko" name="lastName" value={formData.lastName} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-4">
                                <input type="email" className="form-control" placeholder="Email*" name="email" value={formData.email} onChange={handleChange} required />
                            </div>
                            <div className="col-md-4">
                                <input type="tel" className="form-control mt-input" placeholder="Telefon" name="phone" value={formData.phone} onChange={handleChange} pattern="[0-9]*" minLength="9" />
                            </div>
                            <div className="col-md-4">
                                <input type="text" className="form-control mt-input" placeholder="Temat*" name="subject" value={formData.subject} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-12">
                                <textarea className="form-control form-message" placeholder="Wiadomość*" name="message" value={formData.message} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-check mb-4">
                            <input type="checkbox" className="form-check-input" id="acceptTerms" name="acceptTerms" checked={formData.acceptTerms} onChange={handleChange} required />
                            <label className="form-check-label" htmlFor="acceptTerms">Wyrażam zgodę na przetwarzanie moich danych osobowych w celu kontaktu zwrotnego zgodnie z <Link to={'/polityka'}>polityką prywatności</Link>.</label>
                            <p className="fw-lighter">*pola wymagane</p>
                        </div>
                        {error && <div className="alert-danger">{error}</div>}
                        <div className="row text-end">
                            <div className="col-12">
                                <button type="submit" className="btn btn-success btn-wide">Wyślij</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default ContactForm;